import { render, staticRenderFns } from "./EditPerson.vue?vue&type=template&id=250bc5e8"
import script from "./EditPerson.vue?vue&type=script&lang=js"
export * from "./EditPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports